import React from "react";
import { Link } from "react-router-dom";

const TONE = { good: "!text-emerald-700", bad: "!text-red-700", warn: "!text-amber-700" };

// One figure with its label. `hero` fills the tile with the clinic colour; use it once per page,
// on the number the page wants acted on.
export default function Stat({ label, value, hint, hero = false, tone, to, testid, className = "" }) {
  const body = (
    <>
      <p className="label-xs truncate">{label}</p>
      <p className={`dm-stat-value ${!hero && tone ? TONE[tone] : ""}`} data-testid={testid && `${testid}-value`}>{value}</p>
      {hint && <p className="dm-stat-hint">{hint}</p>}
    </>
  );
  const cls = `dm-stat ${hero ? "dm-stat-hero" : ""} ${className}`;
  return to
    ? <Link to={to} data-testid={testid} className={cls}>{body}</Link>
    : <div data-testid={testid} className={cls}>{body}</div>;
}
